export const API = '/api';

export function getToken() {
  return localStorage.getItem('memories_token');
}

export function setToken(token) {
  localStorage.setItem('memories_token', token);
}

export function clearToken() {
  localStorage.removeItem('memories_token');
}

export async function apiFetch(path, options = {}) {
  const token = getToken();
  const headers = {
    ...(options.body && !(options.body instanceof FormData) ? { 'Content-Type': 'application/json' } : {}),
    ...(token ? { 'Authorization': `Bearer ${token}` } : {}),
    ...options.headers,
  };
  const res = await fetch(`${API}${path}`, { ...options, headers });
  if (!res.ok) {
    const err = await res.json().catch(() => ({ error: 'Request failed' }));
    throw new Error(err.error || 'Request failed');
  }
  return res.json();
}

export const DECADES = ['All', '1930s', '1940s', '1950s', '1960s', '1970s', '1980s', '1990s', '2000s', '2010s', '2020s', 'Unknown'];
export const TOPICS = ['All', 'Childhood', 'Family', 'Work', 'Military', 'Education', 'Travel', 'Romance', 'Friends', 'Home', 'Holidays', 'Sports', 'Faith', 'Health', 'Other'];

export const TOPIC_COLORS = {
  Childhood: '#5a8a6a', Family: '#4a7a8a', Work: '#6a7a5a', Military: '#5a6a7a',
  Education: '#6a5a8a', Travel: '#7a6a5a', Romance: '#8a5a6a', Friends: '#5a8a7a',
  Home: '#7a7a5a', Holidays: '#8a6a5a', Sports: '#5a7a6a', Faith: '#6a6a8a',
  Health: '#5a8a5a', Other: '#6a6a6a'
};

// Design tokens — Apple dark mode + sage green
export const c = {
  bg:          '#000000',
  surface:     '#1c1c1e',
  surfaceHigh: '#2c2c2e',
  border:      '#38383a',
  borderLight: '#48484a',
  accent:      '#7ab89a',
  accentDim:   '#4a7a5a',
  accentText:  '#a0d4b4',
  text:        '#ffffff',
  textSec:     '#ebebf599',
  textTert:    '#ebebf54d',
  red:         '#ff453a',
  success:     '#32d74b',
};

export const globalCSS = `
  *, *::before, *::after { box-sizing: border-box; -webkit-tap-highlight-color: transparent; }
  html, body { margin: 0; padding: 0; background: ${c.bg}; color: ${c.text}; font-family: -apple-system, BlinkMacSystemFont, 'SF Pro Text', 'Segoe UI', sans-serif; -webkit-font-smoothing: antialiased; }
  button { font-family: inherit; cursor: pointer; }
  input, select, textarea { font-family: inherit; }
  @keyframes pulse { 0%, 100% { transform: scale(1); opacity: 1; } 50% { transform: scale(1.05); opacity: 0.6; } }
  @keyframes spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }
  @keyframes fadeIn { from { opacity: 0; transform: translateY(6px); } to { opacity: 1; transform: translateY(0); } }
  .fade-in { animation: fadeIn 0.25s ease forwards; }
  select option { background: ${c.surfaceHigh}; }
  input::placeholder, textarea::placeholder { color: ${c.textTert}; }
  ::-webkit-scrollbar { width: 4px; }
  ::-webkit-scrollbar-track { background: transparent; }
  ::-webkit-scrollbar-thumb { background: ${c.border}; border-radius: 2px; }
`;
